// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27none%27 stroke=%27%235a6b80%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27m6 9 6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --sq-brand: #e63b11;
  --sq-brand-strong: #c9320c;
  --sq-brand-stronger: #a82a0a;
  --sq-brand-soft: #fdeee9;
  --sq-navy: #01426a;
  --sq-navy-deep: #012a45;
  --sq-navy-darker: #011f33;
  --sq-sky: #77c5d5;
  --sq-bg: #f3f5f8;
  --sq-surface: #ffffff;
  --sq-surface-2: #f8fafc;
  --sq-surface-3: #eef2f6;
  --sq-border: #e1e7ee;
  --sq-border-strong: #c8d1dc;
  --sq-text: #10212f;
  --sq-text-2: #43546a;
  --sq-text-3: #5a6b80;
  --sq-good: #067647;
  --sq-good-bg: #ecfdf3;
  --sq-good-line: #abefc6;
  --sq-warn: #a85606;
  --sq-warn-bg: #fff8eb;
  --sq-warn-line: #fbd98a;
  --sq-bad: #b42318;
  --sq-bad-bg: #fef3f2;
  --sq-bad-line: #fecdca;
  --sq-info: #01426a;
  --sq-info-bg: #eef7fc;
  --sq-info-line: #b6def0;
  --sq-neutral: #43546a;
  --sq-neutral-bg: #f1f4f8;
  --sq-neutral-line: #dde4ec;
  --sq-cat-available: #45b854;
  --sq-cat-ready: #f08a24;
  --sq-cat-complete: #3a9bb0;
  --sq-cat-in-use: #e9c400;
  --sq-cat-error: #b91c1c;
  --sq-cat-out-of-order: #6c757d;
  --sq-cat-unknown: #adb5bd;
  --sq-font: "Inter Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  --sq-mono: ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace;
  --sq-radius-sm: 8px;
  --sq-radius: 12px;
  --sq-radius-lg: 16px;
  --sq-shadow-sm: 0 1px 2px rgba(16, 33, 47, 0.05);
  --sq-shadow: 0 1px 3px rgba(16, 33, 47, 0.06), 0 6px 16px -8px rgba(16, 33, 47, 0.1);
  --sq-shadow-lg: 0 12px 32px -8px rgba(16, 33, 47, 0.24);
  --sq-focus: 0 0 0 3px rgba(1, 66, 106, 0.28);
  --sq-sidebar-w: 256px;
  --sq-topbar-h: 56px;
  --sq-bottomnav-h: 60px;
  --sq-safe-bottom: env(safe-area-inset-bottom, 0px);
  --sq-page-x: clamp(0.875rem, 2.4vw, 1.75rem);
}

.sq-page {
  padding: 1.25rem var(--sq-page-x) 1.5rem;
  width: 100%;
  max-width: 1680px;
  margin: 0 auto;
  min-width: 0;
}
@media (max-width: 767px) {
  .sq-page {
    padding-top: 0.875rem;
  }
}

.sq-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem 1rem;
  margin-bottom: 1.125rem;
}

.sq-page-heading {
  min-width: 0;
  flex: 1 1 12rem;
}

@media (max-width: 767px) {
  .sq-page-actions .sq-btn-label {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
  }
  .sq-page-actions .btn:has(.sq-btn-label) {
    flex: 0 0 44px;
    width: 44px;
    padding-inline: 0;
  }
}
.sq-page-title {
  font-size: 1.5rem;
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: -0.02em;
  margin: 0;
}
@media (max-width: 991px) {
  .sq-page-title {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
  }
}

.sq-page-sub {
  font-size: 0.8125rem;
  color: var(--sq-text-3);
  margin: 0.25rem 0 0;
  overflow-wrap: anywhere;
}

.sq-page-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}
@media (max-width: 767px) {
  .sq-page-actions > .btn,
  .sq-page-actions > a.btn {
    flex: 1 1 auto;
  }
}

.sq-back {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  min-height: 28px;
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--sq-text-2);
  text-decoration: none;
  margin-bottom: 0.2rem;
}
.sq-back:hover {
  color: var(--sq-navy);
}
@media (pointer: coarse) {
  .sq-back {
    min-height: 40px;
  }
}

.sq-stack {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0;
}

.sq-columns {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  gap: 1rem;
  align-items: start;
}
@media (max-width: 1279px) {
  .sq-columns {
    grid-template-columns: minmax(0, 1fr);
  }
}

.sq-card {
  background: var(--sq-surface);
  border: 1px solid var(--sq-border);
  border-radius: var(--sq-radius);
  box-shadow: var(--sq-shadow-sm);
  min-width: 0;
  scroll-margin-top: calc(var(--sq-topbar-h) + 0.75rem);
}

.sq-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem 0.75rem;
  padding: 0.875rem 1rem;
  border-bottom: 1px solid var(--sq-border);
}

.sq-card-heading {
  min-width: 0;
  flex: 1 1 12rem;
}

.sq-card-title {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.9375rem;
  font-weight: 650;
  margin: 0;
  line-height: 1.35;
}
.sq-card-title svg {
  color: var(--sq-text-3);
  flex-shrink: 0;
}

.sq-card-sub {
  font-size: 0.8125rem;
  color: var(--sq-text-3);
  margin: 0.15rem 0 0;
  line-height: 1.4;
}

.sq-card-body {
  padding: 1rem;
  min-width: 0;
}

.sq-link {
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--sq-navy);
  text-decoration: none;
  white-space: nowrap;
}
.sq-link:hover {
  color: var(--sq-brand-strong);
  text-decoration: underline;
}
@media (pointer: coarse) {
  .sq-link {
    display: inline-flex;
    align-items: center;
    min-height: 40px;
  }
}

.sq-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(10.5rem, 1fr));
  gap: 0.625rem;
  min-width: 0;
}
@media (max-width: 767px) {
  .sq-stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.sq-stats.is-compact {
  grid-template-columns: repeat(auto-fit, minmax(7rem, 1fr));
}
@media (max-width: 767px) {
  .sq-stats.is-compact {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
.sq-stats.is-compact .sq-stat {
  padding: 0.5rem 0.65rem;
  border-radius: var(--sq-radius-sm);
  box-shadow: none;
  background: var(--sq-surface-2);
}
.sq-stats.is-compact .sq-stat-value {
  font-size: 1.0625rem;
  margin-top: 0.1rem;
}
.sq-stats.is-compact .sq-stat-label {
  font-size: 0.6875rem;
}

.sq-stat {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 0.75rem 0.875rem;
  background: var(--sq-surface);
  border: 1px solid var(--sq-border);
  border-radius: var(--sq-radius);
  box-shadow: var(--sq-shadow-sm);
  color: inherit;
  text-align: left;
  text-decoration: none;
}
.sq-stat.is-link {
  cursor: pointer;
  transition: border-color 0.12s ease, box-shadow 0.12s ease;
}
.sq-stat.is-link:hover {
  border-color: var(--sq-navy);
  box-shadow: var(--sq-shadow);
  color: inherit;
  text-decoration: none;
}
.sq-stat.tone-warn, .sq-stat.tone-bad {
  border-color: var(--sq-warn-line);
  box-shadow: inset 3px 0 0 var(--sq-warn), var(--sq-shadow-sm);
}
.sq-stat.tone-bad {
  border-color: var(--sq-bad-line);
  box-shadow: inset 3px 0 0 var(--sq-bad), var(--sq-shadow-sm);
}
.sq-stat.tone-good {
  box-shadow: inset 3px 0 0 var(--sq-good), var(--sq-shadow-sm);
}

.sq-stat-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.4rem;
}

.sq-stat-label {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  min-width: 0;
  margin: 0;
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--sq-text-2);
  line-height: 1.3;
}
.sq-stat-label svg {
  flex-shrink: 0;
  color: var(--sq-text-3);
}
.tone-warn .sq-stat-label svg {
  color: var(--sq-warn);
}
.tone-bad .sq-stat-label svg {
  color: var(--sq-bad);
}
.tone-good .sq-stat-label svg {
  color: var(--sq-good);
}

.sq-stat-value {
  margin: 0.25rem 0 0;
  font-size: 1.625rem;
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: -0.02em;
  color: var(--sq-text);
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}

.sq-stat-unit {
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: 0;
  color: var(--sq-text-3);
}

.sq-stat-note {
  margin: 0.25rem 0 0;
  font-size: 0.75rem;
  color: var(--sq-text-3);
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.sq-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  max-width: 100%;
  padding: 0.1rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.45;
  border-radius: 999px;
  border: 1px solid var(--sq-neutral-line);
  background: var(--sq-neutral-bg);
  color: var(--sq-neutral);
  white-space: nowrap;
}
.sq-pill svg {
  flex-shrink: 0;
}
.sq-pill.tone-good {
  color: var(--sq-good);
  background: var(--sq-good-bg);
  border-color: var(--sq-good-line);
}
.sq-pill.tone-warn {
  color: var(--sq-warn);
  background: var(--sq-warn-bg);
  border-color: var(--sq-warn-line);
}
.sq-pill.tone-bad {
  color: var(--sq-bad);
  background: var(--sq-bad-bg);
  border-color: var(--sq-bad-line);
}
.sq-pill.tone-info {
  color: var(--sq-info);
  background: var(--sq-info-bg);
  border-color: var(--sq-info-line);
}

.sq-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--sq-text-2);
  white-space: nowrap;
}
.sq-tag i {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--tag-color, var(--sq-text-3));
  flex-shrink: 0;
}

.sq-mono {
  font-family: var(--sq-mono);
  font-size: 0.8125em;
  color: var(--sq-text-2);
  overflow-wrap: break-word;
}

.sq-muted {
  font-size: 0.75rem;
  color: var(--sq-text-3);
  line-height: 1.4;
}

.sq-strong {
  font-weight: 600;
  color: var(--sq-text);
}

.sq-table-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-x: contain;
  min-width: 0;
}

.sq-table {
  width: 100%;
  margin: 0;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.875rem;
  color: var(--sq-text);
}
.sq-table th {
  padding: 0.5rem 0.875rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--sq-text-3);
  text-align: left;
  white-space: nowrap;
  background: var(--sq-surface-2);
  border-bottom: 1px solid var(--sq-border);
}
.sq-table th.num {
  text-align: right;
}
.sq-table thead tr:first-child th:first-child {
  border-top-left-radius: calc(var(--sq-radius) - 1px);
}
.sq-table thead tr:first-child th:last-child {
  border-top-right-radius: calc(var(--sq-radius) - 1px);
}
.sq-table td {
  padding: 0.625rem 0.875rem;
  vertical-align: middle;
  border-bottom: 1px solid var(--sq-border);
  overflow-wrap: break-word;
}
.sq-table td.num {
  text-align: right;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.sq-table td.nowrap {
  white-space: nowrap;
}
.sq-table td.truncate {
  max-width: 18rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sq-table td.cell-actions {
  text-align: right;
  white-space: nowrap;
}
.sq-table tbody tr:last-child > td {
  border-bottom: 0;
}
.sq-table tbody tr.is-clickable {
  cursor: pointer;
}
.sq-table tbody tr.is-clickable:hover > td {
  background: var(--sq-surface-2);
}
.sq-table tbody tr.is-flagged > td {
  background: var(--sq-warn-bg);
}
.sq-table tbody tr.is-flagged > td:first-child {
  box-shadow: inset 3px 0 0 var(--sq-warn);
}
.sq-table tbody tr.is-danger > td {
  background: var(--sq-bad-bg);
}
.sq-table tbody tr.is-danger > td:first-child {
  box-shadow: inset 3px 0 0 var(--sq-bad);
}
.sq-table tbody tr.is-detail > td {
  background: var(--sq-surface-2);
  padding: 0.75rem 0.875rem;
}
.sq-table .sortable {
  all: unset;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  cursor: pointer;
  font: inherit;
  border-radius: 4px;
}
.sq-table .sortable:hover {
  color: var(--sq-navy);
}
.sq-table .sortable:focus-visible {
  box-shadow: var(--sq-focus);
}

.sq-value-bad {
  color: var(--sq-bad);
  font-weight: 600;
}

.sq-value-good {
  color: var(--sq-good);
  font-weight: 600;
}

.sq-value-warn {
  color: var(--sq-warn);
  font-weight: 600;
}

@media (max-width: 767px) {
  .sq-table.is-stacked {
    display: block;
    background: transparent;
  }
  .sq-table.is-stacked thead {
    display: none;
  }
  .sq-table.is-stacked tbody {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.625rem;
  }
  .sq-table.is-stacked tbody > tr {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 0.5rem 0.75rem;
    padding: 0.75rem;
    background: var(--sq-surface);
    border: 1px solid var(--sq-border);
    border-radius: var(--sq-radius-sm);
  }
  .sq-table.is-stacked tbody > tr.is-flagged {
    background: var(--sq-warn-bg);
    border-color: var(--sq-warn-line);
    box-shadow: inset 3px 0 0 var(--sq-warn);
  }
  .sq-table.is-stacked tbody > tr.is-danger {
    background: var(--sq-bad-bg);
    border-color: var(--sq-bad-line);
    box-shadow: inset 3px 0 0 var(--sq-bad);
  }
  .sq-table.is-stacked tbody tr > td {
    display: block;
    min-width: 0;
    padding: 0;
    border: 0;
    background: transparent !important;
    box-shadow: none !important;
    text-align: left;
    white-space: normal;
    max-width: none;
  }
  .sq-table.is-stacked tbody tr > td::before {
    content: attr(data-label);
    display: block;
    font-size: 0.6875rem;
    font-weight: 600;
    color: var(--sq-text-3);
    line-height: 1.3;
    margin-bottom: 0.1rem;
  }
  .sq-table.is-stacked tbody tr > td:not([data-label])::before, .sq-table.is-stacked tbody tr > td[data-label=""]::before {
    display: none;
  }
  .sq-table.is-stacked tbody tr > td.is-empty {
    display: none;
  }
  .sq-table.is-stacked td.cell-title,
  .sq-table.is-stacked td.cell-wide,
  .sq-table.is-stacked td.cell-actions {
    grid-column: 1/-1;
  }
  .sq-table.is-stacked td.cell-title {
    font-size: 0.9375rem;
  }
  .sq-table.is-stacked td.cell-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    flex-wrap: wrap;
    text-align: right;
  }
  .sq-table.is-stacked td.truncate {
    overflow-wrap: anywhere;
  }
  .sq-table.is-stacked tr.is-detail {
    display: block;
    margin-top: -0.25rem;
    background: var(--sq-surface-2);
  }
  .sq-table.is-stacked tr.is-detail > td::before {
    display: none;
  }
}
.sq-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.625rem;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--sq-border);
  background: var(--sq-surface);
  border-radius: calc(var(--sq-radius) - 1px) calc(var(--sq-radius) - 1px) 0 0;
}
.sq-toolbar.is-plain {
  padding: 0;
  border: 0;
  background: transparent;
}
.sq-toolbar .sq-toolbar-end {
  margin-left: auto;
  align-self: center;
}
@media (max-width: 767px) {
  .sq-toolbar {
    padding: 0.625rem;
  }
  .sq-toolbar.is-plain {
    padding: 0;
  }
  .sq-toolbar .sq-toolbar-end {
    margin-left: 0;
    width: 100%;
  }
}

.sq-field {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
  margin: 0;
  flex: 0 1 12rem;
}
.sq-field > span {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--sq-text-2);
}
.sq-field.is-grow {
  flex: 1 1 14rem;
}
@media (max-width: 767px) {
  .sq-field {
    flex: 1 1 100%;
  }
  .sq-field.is-half {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 0.625rem);
  }
}

.sq-input {
  width: 100%;
  min-width: 0;
  min-height: 36px;
  padding: 0.375rem 0.625rem;
  font: inherit;
  font-size: 0.875rem;
  color: var(--sq-text);
  background-color: var(--sq-surface);
  border: 1px solid var(--sq-border-strong);
  border-radius: var(--sq-radius-sm);
  transition: border-color 0.12s ease, box-shadow 0.12s ease;
}
.sq-input::placeholder {
  color: var(--sq-text-3);
}
.sq-input:hover:not(:disabled) {
  border-color: var(--sq-text-3);
}
.sq-input:focus {
  outline: none;
  border-color: var(--sq-navy);
  box-shadow: var(--sq-focus);
}
.sq-input:disabled {
  background-color: var(--sq-surface-3);
  color: var(--sq-text-3);
  cursor: not-allowed;
}
@media (pointer: coarse), (max-width: 767px) {
  .sq-input {
    min-height: 44px;
  }
}

select.sq-input {
  appearance: none;
  padding-right: 2rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.55rem center;
  text-overflow: ellipsis;
}

input.sq-input[type=date],
input.sq-input[type=datetime-local] {
  appearance: none;
  min-width: 0;
  max-width: 100%;
}

.sq-count {
  font-size: 0.8125rem;
  color: var(--sq-text-3);
  white-space: nowrap;
}

.sq-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.875rem;
}
.sq-form-grid.is-thirds {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.sq-form-grid .is-full {
  grid-column: 1/-1;
}
@media (max-width: 599px) {
  .sq-form-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .sq-form-grid.is-thirds {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.sq-form-section {
  padding: 1rem 0;
  border-top: 1px solid var(--sq-border);
}
.sq-form-section:first-child {
  padding-top: 0;
  border-top: 0;
}
.sq-form-section:last-child {
  padding-bottom: 0;
}
.sq-form-section > h3 {
  font-size: 0.875rem;
  font-weight: 650;
  margin: 0 0 0.75rem;
}
.sq-form-section > p {
  font-size: 0.8125rem;
  color: var(--sq-text-3);
  margin: -0.5rem 0 0.75rem;
}

.sq-seg {
  display: inline-flex;
  max-width: 100%;
  padding: 3px;
  gap: 2px;
  background: var(--sq-surface-3);
  border-radius: var(--sq-radius-sm);
}
.sq-seg button {
  flex: 1 1 auto;
  appearance: none;
  border: 0;
  background: transparent;
  color: var(--sq-text-2);
  font-size: 0.8125rem;
  font-weight: 600;
  min-height: 30px;
  padding: 0.2rem 0.7rem;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
}
.sq-seg button:hover {
  color: var(--sq-text);
}
.sq-seg button[aria-pressed=true] {
  background: var(--sq-surface);
  color: var(--sq-navy);
  box-shadow: var(--sq-shadow-sm);
}
@media (pointer: coarse), (max-width: 767px) {
  .sq-seg button {
    min-height: 44px;
    min-width: 44px;
  }
}
.sq-seg.is-block {
  display: flex;
  width: 100%;
}

.sq-chips {
  display: flex;
  gap: 0.375rem;
  flex-wrap: wrap;
  min-width: 0;
}
@media (max-width: 767px) {
  .sq-chips {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    margin-inline: calc(var(--sq-page-x) * -1);
    padding-inline: var(--sq-page-x);
    -webkit-overflow-scrolling: touch;
  }
  .sq-chips::-webkit-scrollbar {
    display: none;
  }
}

.sq-chip {
  appearance: none;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  min-height: 30px;
  padding: 0.2rem 0.7rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--sq-text-2);
  background: var(--sq-surface);
  border: 1px solid var(--sq-border-strong);
  border-radius: 999px;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
}
.sq-chip:hover {
  border-color: var(--sq-navy);
  color: var(--sq-navy);
}
.sq-chip.active, .sq-chip[aria-pressed=true] {
  background: var(--sq-navy);
  border-color: var(--sq-navy);
  color: #fff;
}
@media (pointer: coarse), (max-width: 767px) {
  .sq-chip {
    min-height: 40px;
  }
}

.sq-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.sq-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  min-height: 52px;
  padding: 0.625rem 1rem;
  text-align: left;
  color: inherit;
  background: transparent;
  border: 0;
  border-bottom: 1px solid var(--sq-border);
}
li:last-child > .sq-list-item {
  border-bottom: 0;
  border-radius: 0 0 calc(var(--sq-radius) - 1px) calc(var(--sq-radius) - 1px);
}
.sq-list-item.is-clickable {
  cursor: pointer;
}
.sq-list-item.is-clickable:hover {
  background: var(--sq-surface-2);
}

.sq-list-main {
  min-width: 0;
  flex: 1 1;
}

.sq-list-title {
  font-size: 0.875rem;
  font-weight: 600;
  margin: 0;
  overflow-wrap: anywhere;
}

.sq-list-meta {
  font-size: 0.8125rem;
  color: var(--sq-text-3);
  margin: 0.1rem 0 0;
  overflow-wrap: anywhere;
}

.sq-dl {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));
  gap: 0.875rem 1.25rem;
  margin: 0;
  padding: 1rem;
}
@media (max-width: 767px) {
  .sq-dl {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.sq-dl > div {
  min-width: 0;
}
.sq-dl dt {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--sq-text-3);
  margin: 0 0 0.1rem;
}
.sq-dl dd {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 500;
  overflow-wrap: anywhere;
}
.sq-dl .is-wide {
  grid-column: 1/-1;
}

.sq-dl-rows {
  display: grid;
  gap: 0.625rem;
  margin: 0;
}
.sq-dl-rows > div {
  display: grid;
  grid-template-columns: 9.5rem minmax(0, 1fr);
  gap: 0.75rem;
}
@media (max-width: 479px) {
  .sq-dl-rows > div {
    grid-template-columns: minmax(0, 1fr);
    gap: 0.05rem;
  }
}
.sq-dl-rows dt {
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--sq-text-3);
}
.sq-dl-rows dd {
  margin: 0;
  font-size: 0.875rem;
  min-width: 0;
  overflow-wrap: anywhere;
}

.sq-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.25rem;
  padding: 2rem 1.25rem;
  color: var(--sq-text-3);
}
.sq-empty svg {
  color: var(--sq-text-3);
  opacity: 0.75;
  margin-bottom: 0.25rem;
}
.sq-empty h3 {
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--sq-text-2);
  margin: 0;
}
.sq-empty p {
  font-size: 0.8125rem;
  margin: 0;
  max-width: 34rem;
}
.sq-empty .btn {
  margin-top: 0.5rem;
}
.sq-empty.is-compact {
  padding: 1.25rem 1rem;
}

.sq-error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
  padding: 0.625rem 0.875rem;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  color: var(--sq-bad);
  background: var(--sq-bad-bg);
  border: 1px solid var(--sq-bad-line);
  border-radius: var(--sq-radius-sm);
  overflow-wrap: anywhere;
}
.sq-error > span {
  display: inline-flex;
  gap: 0.4rem;
  min-width: 0;
  flex: 1 1 12rem;
}
.sq-error svg {
  flex-shrink: 0;
  margin-top: 0.1rem;
}

.sq-skel {
  display: block;
  height: 0.8125rem;
  border-radius: 6px;
  background: linear-gradient(90deg, #e8edf3 25%, #f2f5f8 37%, #e8edf3 63%);
  background-size: 400% 100%;
  animation: sq-shimmer 1.4s ease infinite;
}
.sq-skel.is-tall {
  height: 1.625rem;
}

.sq-skel-rows {
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
  padding: 1rem;
}

@keyframes sq-shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
.sq-meter {
  display: block;
  height: 8px;
  border-radius: 4px;
  background: var(--sq-surface-3);
  overflow: hidden;
}
.sq-meter > i {
  display: block;
  height: 100%;
  min-width: 4px;
  border-radius: 4px;
  background: var(--sq-navy);
}

.sq-disclosure > summary {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  min-height: 32px;
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--sq-navy);
  cursor: pointer;
  list-style: none;
  -webkit-user-select: none;
          user-select: none;
}
.sq-disclosure > summary::-webkit-details-marker {
  display: none;
}
@media (pointer: coarse) {
  .sq-disclosure > summary {
    min-height: 44px;
  }
}
.sq-disclosure > summary svg {
  transition: transform 0.15s ease;
}
.sq-disclosure[open] > summary svg.sq-chevron {
  transform: rotate(90deg);
}

.sq-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem 0.75rem;
  padding: 0.625rem 1rem;
  font-size: 0.8125rem;
  color: var(--sq-text-3);
  border-top: 1px solid var(--sq-border);
}
.sq-pagination .sq-page-btns {
  display: flex;
  align-items: center;
  gap: 0.375rem;
}
@media (max-width: 767px) {
  .sq-pagination .sq-page-btns {
    width: 100%;
  }
  .sq-pagination .sq-page-btns .btn {
    flex: 1 1;
  }
}

@media (max-width: 767px) {
  .sq-table.is-stacked.cols-3 tbody > tr {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .sq-table.is-stacked.cols-4 tbody > tr {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .sq-table.is-stacked.cols-5 tbody > tr {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .sq-table.is-stacked td.cell-title {
    order: -1;
  }
  .sq-table.is-stacked .sq-table.is-stacked tbody {
    padding: 0;
  }
}
.sq-row-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  color: var(--sq-text-3);
  background: transparent;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
}
.sq-row-toggle:hover {
  color: var(--sq-navy);
  background: var(--sq-surface-3);
}
@media (pointer: coarse), (max-width: 767px) {
  .sq-row-toggle {
    width: 44px;
    height: 44px;
  }
}

.sq-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  color: var(--sq-text-2);
  background: transparent;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
}
.sq-icon-btn:hover {
  color: var(--sq-navy);
  background: var(--sq-surface-3);
}
.sq-icon-btn.is-danger:hover {
  color: var(--sq-bad);
  background: var(--sq-bad-bg);
}
@media (pointer: coarse), (max-width: 767px) {
  .sq-icon-btn {
    width: 44px;
    height: 44px;
  }
}

.sq-text-link {
  color: var(--sq-navy);
  font-weight: 600;
  text-decoration: none;
}
@media (pointer: coarse), (max-width: 767px) {
  .sq-text-link {
    display: inline-block;
    padding-block: 0.7rem;
    margin-block: -0.7rem;
  }
}
.sq-text-link:hover {
  color: var(--sq-brand-strong);
  text-decoration: underline;
}

.sq-tasks {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
}

.sq-filters-toggle {
  display: none;
}
@media (max-width: 767px) {
  .sq-filters-toggle {
    display: inline-flex;
    width: 100%;
  }
}

.sq-filters-body {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.625rem;
  flex: 1 1 100%;
  min-width: 0;
}
@media (max-width: 767px) {
  .sq-filters-body:not(.is-open) {
    display: none;
  }
}

.sq-form-actions {
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
}
@media (max-width: 767px) {
  .sq-form-actions {
    width: 100%;
  }
  .sq-form-actions .btn {
    flex: 1 1;
  }
}

.reports-filter {
  align-items: flex-end;
}

.sq-card-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  min-height: 28px;
  padding: 0;
  font: inherit;
  color: inherit;
  background: transparent;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
}
.sq-card-toggle:hover {
  color: var(--sq-navy);
}
@media (pointer: coarse) {
  .sq-card-toggle {
    min-height: 44px;
  }
}

.sq-clamp {
  display: -webkit-box;
  max-width: 34rem;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

@media (min-width: 1280px) {
  .sq-columns.is-aside-first > aside {
    order: 2;
  }
}

.sq-footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 0.25rem 1rem;
  padding: 0.875rem var(--sq-page-x);
  font-size: 0.75rem;
  color: var(--sq-text-3);
}
.sq-footer a {
  color: var(--sq-text-2);
  font-weight: 600;
  text-decoration: none;
}
@media (pointer: coarse), (max-width: 767px) {
  .sq-footer a {
    display: inline-block;
    padding-block: 0.8rem;
    margin-block: -0.8rem;
  }
}
.sq-footer a:hover {
  color: var(--sq-navy);
  text-decoration: underline;
}

.sq-not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.5rem;
  padding-top: 3rem;
}
.sq-not-found img {
  width: min(100%, 220px);
  height: auto;
}
.sq-not-found h1 {
  font-size: 1.375rem;
  font-weight: 700;
  margin: 0.75rem 0 0;
}
.sq-not-found p {
  color: var(--sq-text-3);
  margin: 0 0 0.75rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/tokens.scss","webpack://./src/styles/components.scss"],"names":[],"mappings":"AAOA;EAGE,mBAAA;EACA,0BAAA;EACA,4BAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,iBAAA;EAGA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,oBAAA;EACA,2BAAA;EAGA,kBAAA;EACA,oBAAA;EACA,oBAAA;EAIA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,wBAAA;EACA,0BAAA;EAGA,2BAAA;EACA,uBAAA;EACA,0BAAA;EACA,wBAAA;EACA,uBAAA;EACA,8BAAA;EACA,yBAAA;EAGA;uCAAA;EAEA,sFAAA;EAGA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gDAAA;EACA,oFAAA;EACA,uDAAA;EACA,4CAAA;EAIA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kDAAA;EACA,4CAAA;ACxBF;;AAjDA;EACE,wCAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AAoDF;AAlDE;EAPF;IAQI,qBAAA;EAqDF;AACF;;AAlDA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AAqDF;;AAlDA;EACE,YAAA;EACA,eAAA;AAqDF;;AAjDA;EACE;IACE,kBAAA;IACA,UAAA;IACA,WAAA;IACA,gBAAA;IACA,qBAAA;IACA,mBAAA;EAoDF;EAjDA;IACE,cAAA;IACA,WAAA;IACA,iBAAA;EAmDF;AACF;AAhDA;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;AAkDF;AA/CE;EARF;IASI,kBAAA;IACA,UAAA;IACA,WAAA;IACA,gBAAA;IACA,qBAAA;IACA,mBAAA;EAkDF;AACF;;AA/CA;EACE,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;AAkDF;;AA/CA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AAkDF;AAhDE;EACE;;IAEE,cAAA;EAkDJ;AACF;;AA9CA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;AAiDF;AA/CE;EACE,qBAAA;AAiDJ;AA9CE;EAfF;IAgBI,gBAAA;EAiDF;AACF;;AA9CA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AAiDF;;AA9CA;EACE,aAAA;EACA,oDAAA;EACA,SAAA;EACA,kBAAA;AAiDF;AA/CE;EANF;IAOI,qCAAA;EAkDF;AACF;;AA7CA;EACE,6BAAA;EACA,kCAAA;EACA,+BAAA;EACA,+BAAA;EACA,YAAA;EACA,qDAAA;AAgDF;;AA7CA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,yCAAA;AAgDF;;AA7CA;EACE,YAAA;EACA,eAAA;AAgDF;;AA7CA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;AAgDF;AA9CE;EACE,uBAAA;EACA,cAAA;AAgDJ;;AA5CA;EACE,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AA+CF;;AA5CA;EACE,aAAA;EACA,YAAA;AA+CF;;AA5CA;EACE,oBAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;AA+CF;AA7CE;EACE,6BAAA;EACA,0BAAA;AA+CJ;AA5CE;EAZF;IAaI,oBAAA;IACA,mBAAA;IACA,gBAAA;EA+CF;AACF;;AA1CA;EACE,aAAA;EACA,6DAAA;EACA,aAAA;EACA,YAAA;AA6CF;AA3CE;EANF;IAOI,gDAAA;EA8CF;AACF;AA5CE;EACE,0DAAA;AA8CJ;AA5CI;EAHF;IAII,gDAAA;EA+CJ;AACF;AA7CI;EACE,uBAAA;EACA,kCAAA;EACA,gBAAA;EACA,+BAAA;AA+CN;AA5CI;EACE,oBAAA;EACA,kBAAA;AA8CN;AA3CI;EACE,oBAAA;AA6CN;;AAxCA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kCAAA;EACA,+BAAA;EACA,+BAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AA2CF;AAzCE;EACE,eAAA;EACA,0DAAA;AA2CJ;AAzCI;EACE,4BAAA;EACA,4BAAA;EACA,cAAA;EACA,qBAAA;AA2CN;AArCE;EAEE,iCAAA;EACA,6DAAA;AAsCJ;AAnCE;EACE,gCAAA;EACA,4DAAA;AAqCJ;AAlCE;EACE,6DAAA;AAoCJ;;AAhCA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,WAAA;AAmCF;;AAhCA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAmCF;AAjCE;EACE,cAAA;EACA,uBAAA;AAmCJ;AAhCE;EACE,qBAAA;AAkCJ;AA/BE;EACE,oBAAA;AAiCJ;AA9BE;EACE,qBAAA;AAgCJ;;AA5BA;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kCAAA;EACA,uBAAA;AA+BF;;AA5BA;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AA+BF;;AA5BA;EACE,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,uBAAA;AA+BF;;AA1BA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,wCAAA;EACA,gCAAA;EACA,wBAAA;EACA,mBAAA;AA6BF;AA3BE;EACE,cAAA;AA6BJ;AA1BE;EACE,qBAAA;EACA,6BAAA;EACA,iCAAA;AA4BJ;AAzBE;EACE,qBAAA;EACA,6BAAA;EACA,iCAAA;AA2BJ;AAxBE;EACE,oBAAA;EACA,4BAAA;EACA,gCAAA;AA0BJ;AAvBE;EACE,qBAAA;EACA,6BAAA;EACA,iCAAA;AAyBJ;;AArBA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAwBF;AAtBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,8CAAA;EACA,cAAA;AAwBJ;;AApBA;EACE,2BAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AAuBF;;AApBA;EACE,kBAAA;EACA,uBAAA;EACA,gBAAA;AAuBF;;AApBA;EACE,gBAAA;EACA,qBAAA;AAuBF;;AAbA;EACE,gBAAA;EACA,iCAAA;EACA,8BAAA;EACA,YAAA;AAgBF;;AAbA;EACE,WAAA;EACA,SAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;AAgBF;AAdE;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;EACA,yCAAA;AAgBJ;AAdI;EACE,iBAAA;AAgBN;AAZE;EACE,oDAAA;AAcJ;AAXE;EACE,qDAAA;AAaJ;AAVE;EACE,0BAAA;EACA,sBAAA;EACA,yCAAA;EACA,yBAAA;AAYJ;AAVI;EACE,iBAAA;EACA,kCAAA;EACA,mBAAA;AAYN;AATI;EACE,mBAAA;AAWN;AARI;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAUN;AAPI;EACE,iBAAA;EACA,mBAAA;AASN;AALE;EACE,gBAAA;AAOJ;AAJE;EACE,eAAA;AAMJ;AAJI;EACE,+BAAA;AAMN;AAFE;EACE,6BAAA;AAIJ;AADE;EACE,wCAAA;AAGJ;AAAE;EACE,4BAAA;AAEJ;AACE;EACE,uCAAA;AACJ;AAEE;EACE,+BAAA;EACA,yBAAA;AAAJ;AAGE;EACE,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AADJ;AAGI;EACE,qBAAA;AADN;AAII;EACE,2BAAA;AAFN;;AAOA;EACE,oBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,qBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,qBAAA;EACA,gBAAA;AAJF;;AAOA;EACE;IACE,cAAA;IACA,uBAAA;EAJF;EAME;IACE,aAAA;EAJJ;EAOE;IACE,aAAA;IACA,sBAAA;IACA,WAAA;IACA,iBAAA;EALJ;EAQE;IACE,aAAA;IACA,oDAAA;IACA,mBAAA;IACA,gBAAA;IACA,6BAAA;IACA,kCAAA;IACA,kCAAA;EANJ;EASE;IACE,6BAAA;IACA,iCAAA;IACA,wCAAA;EAPJ;EAUE;IACE,4BAAA;IACA,gCAAA;IACA,uCAAA;EARJ;EAWE;IACE,cAAA;IACA,YAAA;IACA,UAAA;IACA,SAAA;IACA,kCAAA;IACA,2BAAA;IACA,gBAAA;IACA,mBAAA;IACA,eAAA;EATJ;EAWI;IACE,yBAAA;IACA,cAAA;IACA,oBAAA;IACA,gBAAA;IACA,uBAAA;IACA,gBAAA;IACA,qBAAA;EATN;EAYI;IAEE,aAAA;EAXN;EAcI;IACE,aAAA;EAZN;EAgBE;;;IAGE,iBAAA;EAdJ;EAiBE;IACE,oBAAA;EAfJ;EAkBE;IACE,aAAA;IACA,yBAAA;IACA,WAAA;IACA,eAAA;IACA,iBAAA;EAhBJ;EAmBE;IACE,uBAAA;EAjBJ;EAoBE;IACE,cAAA;IACA,oBAAA;IACA,+BAAA;EAlBJ;EAqBE;IACE,aAAA;EAnBJ;AACF;AAyBA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;EACA,yCAAA;EACA,6BAAA;EACA,4EAAA;AAvBF;AAyBE;EACE,UAAA;EACA,SAAA;EACA,uBAAA;AAvBJ;AA0BE;EACE,iBAAA;EACA,kBAAA;AAxBJ;AA2BE;EArBF;IAsBI,iBAAA;EAxBF;EA0BE;IACE,UAAA;EAxBJ;EA2BE;IACE,cAAA;IACA,WAAA;EAzBJ;AACF;;AA6BA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;AA1BF;AA4BE;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;AA1BJ;AA6BE;EACE,eAAA;AA3BJ;AA8BE;EAlBF;IAmBI,cAAA;EA3BF;EA6BE;IACE,YAAA;IAAA,cAAA;IAAA,gCAAA;EA3BJ;AACF;;AA+BA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,mCAAA;EACA,yCAAA;EACA,kCAAA;EACA,0DAAA;AA5BF;AA8BE;EACE,uBAAA;AA5BJ;AA+BE;EACE,8BAAA;AA7BJ;AAgCE;EACE,aAAA;EACA,4BAAA;EACA,2BAAA;AA9BJ;AAiCE;EACE,qCAAA;EACA,uBAAA;EACA,mBAAA;AA/BJ;AAkCE;EAjCF;IAkCI,gBAAA;EA/BF;AACF;;AAkCA;EACE,gBAAA;EACA,mBAAA;EACA,yDAAA;EACA,4BAAA;EACA,yCAAA;EACA,uBAAA;AA/BF;;AAmCA;;EAGE,gBAAA;EACA,YAAA;EACA,eAAA;AAhCF;;AAmCA;EACE,oBAAA;EACA,uBAAA;EACA,mBAAA;AAhCF;;AAmCA;EACE,aAAA;EACA,gDAAA;EACA,aAAA;AAhCF;AAkCE;EACE,gDAAA;AAhCJ;AAmCE;EACE,iBAAA;AAjCJ;AAoCE;EAbF;IAcI,qCAAA;EAjCF;EAmCE;IACE,gDAAA;EAjCJ;AACF;;AAqCA;EACE,eAAA;EACA,sCAAA;AAlCF;AAoCE;EACE,cAAA;EACA,aAAA;AAlCJ;AAqCE;EACE,iBAAA;AAnCJ;AAsCE;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;AApCJ;AAuCE;EACE,oBAAA;EACA,uBAAA;EACA,yBAAA;AArCJ;;AA2CA;EACE,oBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,+BAAA;EACA,kCAAA;AAxCF;AA0CE;EACE,cAAA;EACA,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAxCJ;AA0CI;EACE,qBAAA;AAxCN;AA2CI;EACE,6BAAA;EACA,qBAAA;EACA,+BAAA;AAzCN;AA4CI;EAxBF;IAyBI,gBAAA;IACA,eAAA;EAzCJ;AACF;AA4CE;EACE,aAAA;EACA,WAAA;AA1CJ;;AA8CA;EACE,aAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;AA3CF;AA8CE;EAPF;IAQI,iBAAA;IACA,gBAAA;IACA,qBAAA;IACA,0CAAA;IACA,gCAAA;IACA,iCAAA;EA3CF;EA6CE;IACE,aAAA;EA3CJ;AACF;;AA+CA;EACE,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,6BAAA;EACA,yCAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;AA5CF;AA8CE;EACE,4BAAA;EACA,qBAAA;AA5CJ;AA+CE;EAEE,0BAAA;EACA,4BAAA;EACA,WAAA;AA9CJ;AAiDE;EA9BF;IA+BI,gBAAA;EA9CF;AACF;;AAmDA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AAhDF;;AAmDA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,SAAA;EACA,yCAAA;AAhDF;AAkDE;EACE,gBAAA;EACA,4EAAA;AAhDJ;AAmDE;EACE,eAAA;AAjDJ;AAmDI;EACE,+BAAA;AAjDN;;AAsDA;EACE,YAAA;EACA,SAAA;AAnDF;;AAsDA;EACE,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,uBAAA;AAnDF;;AAsDA;EACE,oBAAA;EACA,uBAAA;EACA,kBAAA;EACA,uBAAA;AAnDF;;AAwDA;EACE,aAAA;EACA,2DAAA;EACA,qBAAA;EACA,SAAA;EACA,aAAA;AArDF;AAuDE;EAPF;IAQI,gDAAA;EApDF;AACF;AAsDE;EACE,YAAA;AApDJ;AAuDE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AArDJ;AAwDE;EACE,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAtDJ;AAyDE;EACE,iBAAA;AAvDJ;;AA2DA;EACE,aAAA;EACA,aAAA;EACA,SAAA;AAxDF;AA0DE;EACE,aAAA;EACA,4CAAA;EACA,YAAA;AAxDJ;AA0DI;EALF;IAMI,qCAAA;IACA,YAAA;EAvDJ;AACF;AA0DE;EACE,oBAAA;EACA,gBAAA;EACA,uBAAA;AAxDJ;AA2DE;EACE,SAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;AAzDJ;;AA+DA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;AA5DF;AA8DE;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;AA5DJ;AA+DE;EACE,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;AA7DJ;AAgEE;EACE,oBAAA;EACA,SAAA;EACA,gBAAA;AA9DJ;AAiEE;EACE,kBAAA;AA/DJ;AAkEE;EACE,qBAAA;AAhEJ;;AAoEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;EACA,0BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,4BAAA;EACA,oCAAA;EACA,kCAAA;EACA,uBAAA;AAjEF;AAmEE;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAjEJ;AAoEE;EACE,cAAA;EACA,kBAAA;AAlEJ;;AAsEA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,yEAAA;EACA,0BAAA;EACA,wCAAA;AAnEF;AAqEE;EACE,gBAAA;AAnEJ;;AAuEA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;AApEF;;AAuEA;EACE;IACE,6BAAA;EApEF;EAuEA;IACE,0BAAA;EArEF;AACF;AAwEA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,gBAAA;AAtEF;AAwEE;EACE,cAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,0BAAA;AAtEJ;;AA4EE;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;AAzEJ;AA2EI;EACE,aAAA;AAzEN;AA4EI;EAhBF;IAiBI,gBAAA;EAzEJ;AACF;AA4EE;EACE,gCAAA;AA1EJ;AA6EE;EACE,wBAAA;AA3EJ;;AA+EA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,oBAAA;EACA,uBAAA;EACA,sCAAA;AA5EF;AA8EE;EACE,aAAA;EACA,mBAAA;EACA,aAAA;AA5EJ;AA8EI;EALF;IAMI,WAAA;EA3EJ;EA6EI;IACE,SAAA;EA3EN;AACF;;AAkFA;EAGI;IACE,gDAAA;EAjFJ;EAoFE;IACE,gDAAA;EAlFJ;EAqFE;IACE,gDAAA;EAnFJ;EAsFE;IACE,SAAA;EApFJ;EAwFE;IACE,UAAA;EAtFJ;AACF;AA4FA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AA1FF;AA4FE;EACE,qBAAA;EACA,+BAAA;AA1FJ;AA6FE;EAlBF;IAmBI,WAAA;IACA,YAAA;EA1FF;AACF;;AA6FA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AA1FF;AA4FE;EACE,qBAAA;EACA,+BAAA;AA1FJ;AA6FE;EACE,oBAAA;EACA,4BAAA;AA3FJ;AA8FE;EAvBF;IAwBI,WAAA;IACA,YAAA;EA3FF;AACF;;AA8FA;EACE,qBAAA;EACA,gBAAA;EACA,qBAAA;AA3FF;AA8FE;EANF;IAOI,qBAAA;IACA,qBAAA;IACA,qBAAA;EA3FF;AACF;AA6FE;EACE,6BAAA;EACA,0BAAA;AA3FJ;;AA+FA;EACE,aAAA;EACA,eAAA;EACA,YAAA;AA5FF;;AAiGA;EACE,aAAA;AA9FF;AAgGE;EAHF;IAII,oBAAA;IACA,WAAA;EA7FF;AACF;;AAgGA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;AA7FF;AA+FE;EACE;IACE,aAAA;EA7FJ;AACF;;AAiGA;EACE,aAAA;EACA,qBAAA;EACA,WAAA;AA9FF;AAgGE;EALF;IAMI,WAAA;EA7FF;EA+FE;IACE,SAAA;EA7FJ;AACF;;AAiGA;EACE,qBAAA;AA9FF;;AAkGA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AA/FF;AAiGE;EACE,qBAAA;AA/FJ;AAkGE;EAjBF;IAkBI,gBAAA;EA/FF;AACF;;AAkGA;EACE,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,qBAAA;AA/FF;;AAoGE;EACE;IACE,QAAA;EAjGJ;AACF;;AAuGA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,iBAAA;EACA,kCAAA;EACA,kBAAA;EACA,uBAAA;AApGF;AAsGE;EACE,uBAAA;EACA,gBAAA;EACA,qBAAA;AApGJ;AAsGI;EALF;IAMI,qBAAA;IACA,qBAAA;IACA,qBAAA;EAnGJ;AACF;AAqGI;EACE,qBAAA;EACA,0BAAA;AAnGN;;AAwGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AArGF;AAuGE;EACE,uBAAA;EACA,YAAA;AArGJ;AAwGE;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;AAtGJ;AAyGE;EACE,uBAAA;EACA,mBAAA;AAvGJ","sourcesContent":["// Design tokens — the single source of truth for colour, type, space and depth.\n// Every component reads these CSS variables; nothing else should hard-code a hex.\n\n// Breakpoints (Sass only — media queries can't read CSS variables).\n$bp-phone: 767px; // Up to here: single column, stacked tables, bottom sheets.\n$bp-shell: 991px; // Up to here: top bar + bottom nav instead of the sidebar.\n\n:root {\n  // Brand. `--sq-brand` is the logo orange, used for accents and large marks.\n  // `--sq-brand-strong` carries white text at AA contrast (the logo orange is 4.2:1).\n  --sq-brand: #e63b11;\n  --sq-brand-strong: #c9320c;\n  --sq-brand-stronger: #a82a0a;\n  --sq-brand-soft: #fdeee9;\n  --sq-navy: #01426a;\n  --sq-navy-deep: #012a45;\n  --sq-navy-darker: #011f33;\n  --sq-sky: #77c5d5;\n\n  // Surfaces and lines.\n  --sq-bg: #f3f5f8;\n  --sq-surface: #ffffff;\n  --sq-surface-2: #f8fafc;\n  --sq-surface-3: #eef2f6;\n  --sq-border: #e1e7ee;\n  --sq-border-strong: #c8d1dc;\n\n  // Text.\n  --sq-text: #10212f;\n  --sq-text-2: #43546a;\n  --sq-text-3: #5a6b80;\n\n  // Status tones. Reserved for state — never decoration — and always paired\n  // with a label or icon so meaning never rests on colour alone.\n  --sq-good: #067647;\n  --sq-good-bg: #ecfdf3;\n  --sq-good-line: #abefc6;\n  --sq-warn: #a85606;\n  --sq-warn-bg: #fff8eb;\n  --sq-warn-line: #fbd98a;\n  --sq-bad: #b42318;\n  --sq-bad-bg: #fef3f2;\n  --sq-bad-line: #fecdca;\n  --sq-info: #01426a;\n  --sq-info-bg: #eef7fc;\n  --sq-info-line: #b6def0;\n  --sq-neutral: #43546a;\n  --sq-neutral-bg: #f1f4f8;\n  --sq-neutral-line: #dde4ec;\n\n  // Machine states on the Status page.\n  --sq-cat-available: #45b854;\n  --sq-cat-ready: #f08a24;\n  --sq-cat-complete: #3a9bb0;\n  --sq-cat-in-use: #e9c400;\n  --sq-cat-error: #b91c1c;\n  --sq-cat-out-of-order: #6c757d;\n  --sq-cat-unknown: #adb5bd;\n\n  // Type.\n  --sq-font: \"Inter Variable\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    \"Helvetica Neue\", Arial, sans-serif;\n  --sq-mono: ui-monospace, SFMono-Regular, Menlo, Consolas, \"Liberation Mono\", monospace;\n\n  // Shape and depth.\n  --sq-radius-sm: 8px;\n  --sq-radius: 12px;\n  --sq-radius-lg: 16px;\n  --sq-shadow-sm: 0 1px 2px rgba(16, 33, 47, 0.05);\n  --sq-shadow: 0 1px 3px rgba(16, 33, 47, 0.06), 0 6px 16px -8px rgba(16, 33, 47, 0.1);\n  --sq-shadow-lg: 0 12px 32px -8px rgba(16, 33, 47, 0.24);\n  --sq-focus: 0 0 0 3px rgba(1, 66, 106, 0.28);\n\n  // Shell. The bottom offset keeps content clear of the fixed nav and the\n  // iPhone home indicator.\n  --sq-sidebar-w: 256px;\n  --sq-topbar-h: 56px;\n  --sq-bottomnav-h: 60px;\n  --sq-safe-bottom: env(safe-area-inset-bottom, 0px);\n  --sq-page-x: clamp(0.875rem, 2.4vw, 1.75rem);\n}\n","// Shared component layer. Pages compose these instead of writing their own card,\n// pill and table styles — the app had about eight separate copies of each.\n@import \"./tokens.scss\";\n\n// Page ----------------------------------------------------------------------\n\n.sq-page {\n  padding: 1.25rem var(--sq-page-x) 1.5rem;\n  width: 100%;\n  max-width: 1680px;\n  margin: 0 auto;\n  min-width: 0;\n\n  @media (max-width: $bp-phone) {\n    padding-top: 0.875rem;\n  }\n}\n\n.sq-page-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem 1rem;\n  margin-bottom: 1.125rem;\n}\n\n.sq-page-heading {\n  min-width: 0;\n  flex: 1 1 12rem;\n}\n\n// Refresh and download shrink to icons so they share a row with the subtitle.\n@media (max-width: $bp-phone) {\n  .sq-page-actions .sq-btn-label {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n    clip-path: inset(50%);\n    white-space: nowrap;\n  }\n\n  .sq-page-actions .btn:has(.sq-btn-label) {\n    flex: 0 0 44px;\n    width: 44px;\n    padding-inline: 0;\n  }\n}\n\n.sq-page-title {\n  font-size: 1.5rem;\n  line-height: 1.2;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  margin: 0;\n\n  // The top bar already names the page; keep the h1 for screen readers.\n  @media (max-width: $bp-shell) {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n    clip-path: inset(50%);\n    white-space: nowrap;\n  }\n}\n\n.sq-page-sub {\n  font-size: 0.8125rem;\n  color: var(--sq-text-3);\n  margin: 0.25rem 0 0;\n  overflow-wrap: anywhere;\n}\n\n.sq-page-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n\n  @media (max-width: $bp-phone) {\n    > .btn,\n    > a.btn {\n      flex: 1 1 auto;\n    }\n  }\n}\n\n.sq-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.2rem;\n  min-height: 28px;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--sq-text-2);\n  text-decoration: none;\n  margin-bottom: 0.2rem;\n\n  &:hover {\n    color: var(--sq-navy);\n  }\n\n  @media (pointer: coarse) {\n    min-height: 40px;\n  }\n}\n\n.sq-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  min-width: 0;\n}\n\n.sq-columns {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);\n  gap: 1rem;\n  align-items: start;\n\n  @media (max-width: 1279px) {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n// Card ----------------------------------------------------------------------\n\n.sq-card {\n  background: var(--sq-surface);\n  border: 1px solid var(--sq-border);\n  border-radius: var(--sq-radius);\n  box-shadow: var(--sq-shadow-sm);\n  min-width: 0;\n  scroll-margin-top: calc(var(--sq-topbar-h) + 0.75rem);\n}\n\n.sq-card-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.5rem 0.75rem;\n  padding: 0.875rem 1rem;\n  border-bottom: 1px solid var(--sq-border);\n}\n\n.sq-card-heading {\n  min-width: 0;\n  flex: 1 1 12rem;\n}\n\n.sq-card-title {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.9375rem;\n  font-weight: 650;\n  margin: 0;\n  line-height: 1.35;\n\n  svg {\n    color: var(--sq-text-3);\n    flex-shrink: 0;\n  }\n}\n\n.sq-card-sub {\n  font-size: 0.8125rem;\n  color: var(--sq-text-3);\n  margin: 0.15rem 0 0;\n  line-height: 1.4;\n}\n\n.sq-card-body {\n  padding: 1rem;\n  min-width: 0;\n}\n\n.sq-link {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--sq-navy);\n  text-decoration: none;\n  white-space: nowrap;\n\n  &:hover {\n    color: var(--sq-brand-strong);\n    text-decoration: underline;\n  }\n\n  @media (pointer: coarse) {\n    display: inline-flex;\n    align-items: center;\n    min-height: 40px;\n  }\n}\n\n// Stat tiles ----------------------------------------------------------------\n\n.sq-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(10.5rem, 1fr));\n  gap: 0.625rem;\n  min-width: 0;\n\n  @media (max-width: $bp-phone) {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  &.is-compact {\n    grid-template-columns: repeat(auto-fit, minmax(7rem, 1fr));\n\n    @media (max-width: $bp-phone) {\n      grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n\n    .sq-stat {\n      padding: 0.5rem 0.65rem;\n      border-radius: var(--sq-radius-sm);\n      box-shadow: none;\n      background: var(--sq-surface-2);\n    }\n\n    .sq-stat-value {\n      font-size: 1.0625rem;\n      margin-top: 0.1rem;\n    }\n\n    .sq-stat-label {\n      font-size: 0.6875rem;\n    }\n  }\n}\n\n.sq-stat {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  padding: 0.75rem 0.875rem;\n  background: var(--sq-surface);\n  border: 1px solid var(--sq-border);\n  border-radius: var(--sq-radius);\n  box-shadow: var(--sq-shadow-sm);\n  color: inherit;\n  text-align: left;\n  text-decoration: none;\n\n  &.is-link {\n    cursor: pointer;\n    transition: border-color 0.12s ease, box-shadow 0.12s ease;\n\n    &:hover {\n      border-color: var(--sq-navy);\n      box-shadow: var(--sq-shadow);\n      color: inherit;\n      text-decoration: none;\n    }\n  }\n\n  // A rule on the leading edge marks a tile needing attention; the label and\n  // icon carry the meaning, the number stays in text ink.\n  &.tone-warn,\n  &.tone-bad {\n    border-color: var(--sq-warn-line);\n    box-shadow: inset 3px 0 0 var(--sq-warn), var(--sq-shadow-sm);\n  }\n\n  &.tone-bad {\n    border-color: var(--sq-bad-line);\n    box-shadow: inset 3px 0 0 var(--sq-bad), var(--sq-shadow-sm);\n  }\n\n  &.tone-good {\n    box-shadow: inset 3px 0 0 var(--sq-good), var(--sq-shadow-sm);\n  }\n}\n\n.sq-stat-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.4rem;\n}\n\n.sq-stat-label {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  min-width: 0;\n  margin: 0;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: var(--sq-text-2);\n  line-height: 1.3;\n\n  svg {\n    flex-shrink: 0;\n    color: var(--sq-text-3);\n  }\n\n  .tone-warn & svg {\n    color: var(--sq-warn);\n  }\n\n  .tone-bad & svg {\n    color: var(--sq-bad);\n  }\n\n  .tone-good & svg {\n    color: var(--sq-good);\n  }\n}\n\n.sq-stat-value {\n  margin: 0.25rem 0 0;\n  font-size: 1.625rem;\n  font-weight: 700;\n  line-height: 1.15;\n  letter-spacing: -0.02em;\n  color: var(--sq-text);\n  font-variant-numeric: tabular-nums;\n  overflow-wrap: anywhere;\n}\n\n.sq-stat-unit {\n  font-size: 0.875rem;\n  font-weight: 500;\n  letter-spacing: 0;\n  color: var(--sq-text-3);\n}\n\n.sq-stat-note {\n  margin: 0.25rem 0 0;\n  font-size: 0.75rem;\n  color: var(--sq-text-3);\n  line-height: 1.35;\n  overflow-wrap: anywhere;\n}\n\n// Pills and tags ------------------------------------------------------------\n\n.sq-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  max-width: 100%;\n  padding: 0.1rem 0.5rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1.45;\n  border-radius: 999px;\n  border: 1px solid var(--sq-neutral-line);\n  background: var(--sq-neutral-bg);\n  color: var(--sq-neutral);\n  white-space: nowrap;\n\n  svg {\n    flex-shrink: 0;\n  }\n\n  &.tone-good {\n    color: var(--sq-good);\n    background: var(--sq-good-bg);\n    border-color: var(--sq-good-line);\n  }\n\n  &.tone-warn {\n    color: var(--sq-warn);\n    background: var(--sq-warn-bg);\n    border-color: var(--sq-warn-line);\n  }\n\n  &.tone-bad {\n    color: var(--sq-bad);\n    background: var(--sq-bad-bg);\n    border-color: var(--sq-bad-line);\n  }\n\n  &.tone-info {\n    color: var(--sq-info);\n    background: var(--sq-info-bg);\n    border-color: var(--sq-info-line);\n  }\n}\n\n.sq-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--sq-text-2);\n  white-space: nowrap;\n\n  i {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: var(--tag-color, var(--sq-text-3));\n    flex-shrink: 0;\n  }\n}\n\n.sq-mono {\n  font-family: var(--sq-mono);\n  font-size: 0.8125em;\n  color: var(--sq-text-2);\n  overflow-wrap: break-word;\n}\n\n.sq-muted {\n  font-size: 0.75rem;\n  color: var(--sq-text-3);\n  line-height: 1.4;\n}\n\n.sq-strong {\n  font-weight: 600;\n  color: var(--sq-text);\n}\n\n// Tables --------------------------------------------------------------------\n//\n// `.sq-table` is the desktop table. Add `.is-stacked` and give each cell a\n// `data-label`, and under the phone breakpoint every row becomes a labelled card\n// instead of a sideways-scrolling strip. `.cell-title` is the card's heading and\n// `.cell-actions` its footer.\n\n.sq-table-wrap {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior-x: contain;\n  min-width: 0;\n}\n\n.sq-table {\n  width: 100%;\n  margin: 0;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 0.875rem;\n  color: var(--sq-text);\n\n  th {\n    padding: 0.5rem 0.875rem;\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: var(--sq-text-3);\n    text-align: left;\n    white-space: nowrap;\n    background: var(--sq-surface-2);\n    border-bottom: 1px solid var(--sq-border);\n\n    &.num {\n      text-align: right;\n    }\n  }\n\n  thead tr:first-child th:first-child {\n    border-top-left-radius: calc(var(--sq-radius) - 1px);\n  }\n\n  thead tr:first-child th:last-child {\n    border-top-right-radius: calc(var(--sq-radius) - 1px);\n  }\n\n  td {\n    padding: 0.625rem 0.875rem;\n    vertical-align: middle;\n    border-bottom: 1px solid var(--sq-border);\n    overflow-wrap: break-word;\n\n    &.num {\n      text-align: right;\n      font-variant-numeric: tabular-nums;\n      white-space: nowrap;\n    }\n\n    &.nowrap {\n      white-space: nowrap;\n    }\n\n    &.truncate {\n      max-width: 18rem;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    &.cell-actions {\n      text-align: right;\n      white-space: nowrap;\n    }\n  }\n\n  tbody tr:last-child > td {\n    border-bottom: 0;\n  }\n\n  tbody tr.is-clickable {\n    cursor: pointer;\n\n    &:hover > td {\n      background: var(--sq-surface-2);\n    }\n  }\n\n  tbody tr.is-flagged > td {\n    background: var(--sq-warn-bg);\n  }\n\n  tbody tr.is-flagged > td:first-child {\n    box-shadow: inset 3px 0 0 var(--sq-warn);\n  }\n\n  tbody tr.is-danger > td {\n    background: var(--sq-bad-bg);\n  }\n\n  tbody tr.is-danger > td:first-child {\n    box-shadow: inset 3px 0 0 var(--sq-bad);\n  }\n\n  tbody tr.is-detail > td {\n    background: var(--sq-surface-2);\n    padding: 0.75rem 0.875rem;\n  }\n\n  .sortable {\n    all: unset;\n    display: inline-flex;\n    align-items: center;\n    gap: 0.25rem;\n    cursor: pointer;\n    font: inherit;\n    border-radius: 4px;\n\n    &:hover {\n      color: var(--sq-navy);\n    }\n\n    &:focus-visible {\n      box-shadow: var(--sq-focus);\n    }\n  }\n}\n\n.sq-value-bad {\n  color: var(--sq-bad);\n  font-weight: 600;\n}\n\n.sq-value-good {\n  color: var(--sq-good);\n  font-weight: 600;\n}\n\n.sq-value-warn {\n  color: var(--sq-warn);\n  font-weight: 600;\n}\n\n@media (max-width: $bp-phone) {\n  .sq-table.is-stacked {\n    display: block;\n    background: transparent;\n\n    thead {\n      display: none;\n    }\n\n    tbody {\n      display: flex;\n      flex-direction: column;\n      gap: 0.5rem;\n      padding: 0.625rem;\n    }\n\n    tbody > tr {\n      display: grid;\n      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n      gap: 0.5rem 0.75rem;\n      padding: 0.75rem;\n      background: var(--sq-surface);\n      border: 1px solid var(--sq-border);\n      border-radius: var(--sq-radius-sm);\n    }\n\n    tbody > tr.is-flagged {\n      background: var(--sq-warn-bg);\n      border-color: var(--sq-warn-line);\n      box-shadow: inset 3px 0 0 var(--sq-warn);\n    }\n\n    tbody > tr.is-danger {\n      background: var(--sq-bad-bg);\n      border-color: var(--sq-bad-line);\n      box-shadow: inset 3px 0 0 var(--sq-bad);\n    }\n\n    tbody tr > td {\n      display: block;\n      min-width: 0;\n      padding: 0;\n      border: 0;\n      background: transparent !important;\n      box-shadow: none !important;\n      text-align: left;\n      white-space: normal;\n      max-width: none;\n\n      &::before {\n        content: attr(data-label);\n        display: block;\n        font-size: 0.6875rem;\n        font-weight: 600;\n        color: var(--sq-text-3);\n        line-height: 1.3;\n        margin-bottom: 0.1rem;\n      }\n\n      &:not([data-label])::before,\n      &[data-label=\"\"]::before {\n        display: none;\n      }\n\n      &.is-empty {\n        display: none;\n      }\n    }\n\n    td.cell-title,\n    td.cell-wide,\n    td.cell-actions {\n      grid-column: 1 / -1;\n    }\n\n    td.cell-title {\n      font-size: 0.9375rem;\n    }\n\n    td.cell-actions {\n      display: flex;\n      justify-content: flex-end;\n      gap: 0.5rem;\n      flex-wrap: wrap;\n      text-align: right;\n    }\n\n    td.truncate {\n      overflow-wrap: anywhere;\n    }\n\n    tr.is-detail {\n      display: block;\n      margin-top: -0.25rem;\n      background: var(--sq-surface-2);\n    }\n\n    tr.is-detail > td::before {\n      display: none;\n    }\n  }\n}\n\n// Toolbars and fields -------------------------------------------------------\n\n.sq-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0.625rem;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--sq-border);\n  background: var(--sq-surface);\n  border-radius: calc(var(--sq-radius) - 1px) calc(var(--sq-radius) - 1px) 0 0;\n\n  &.is-plain {\n    padding: 0;\n    border: 0;\n    background: transparent;\n  }\n\n  .sq-toolbar-end {\n    margin-left: auto;\n    align-self: center;\n  }\n\n  @media (max-width: $bp-phone) {\n    padding: 0.625rem;\n\n    &.is-plain {\n      padding: 0;\n    }\n\n    .sq-toolbar-end {\n      margin-left: 0;\n      width: 100%;\n    }\n  }\n}\n\n.sq-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  min-width: 0;\n  margin: 0;\n  flex: 0 1 12rem;\n\n  > span {\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: var(--sq-text-2);\n  }\n\n  &.is-grow {\n    flex: 1 1 14rem;\n  }\n\n  @media (max-width: $bp-phone) {\n    flex: 1 1 100%;\n\n    &.is-half {\n      flex: 1 1 calc(50% - 0.625rem);\n    }\n  }\n}\n\n.sq-input {\n  width: 100%;\n  min-width: 0;\n  min-height: 36px;\n  padding: 0.375rem 0.625rem;\n  font: inherit;\n  font-size: 0.875rem;\n  color: var(--sq-text);\n  background-color: var(--sq-surface);\n  border: 1px solid var(--sq-border-strong);\n  border-radius: var(--sq-radius-sm);\n  transition: border-color 0.12s ease, box-shadow 0.12s ease;\n\n  &::placeholder {\n    color: var(--sq-text-3);\n  }\n\n  &:hover:not(:disabled) {\n    border-color: var(--sq-text-3);\n  }\n\n  &:focus {\n    outline: none;\n    border-color: var(--sq-navy);\n    box-shadow: var(--sq-focus);\n  }\n\n  &:disabled {\n    background-color: var(--sq-surface-3);\n    color: var(--sq-text-3);\n    cursor: not-allowed;\n  }\n\n  @media (pointer: coarse), (max-width: $bp-phone) {\n    min-height: 44px;\n  }\n}\n\nselect.sq-input {\n  appearance: none;\n  padding-right: 2rem;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' stroke='%235a6b80' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' viewBox='0 0 24 24'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 0.55rem center;\n  text-overflow: ellipsis;\n}\n\n// iOS gives date inputs an intrinsic width that ignores `width: 100%`.\ninput.sq-input[type=\"date\"],\ninput.sq-input[type=\"datetime-local\"] {\n  -webkit-appearance: none;\n  appearance: none;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.sq-count {\n  font-size: 0.8125rem;\n  color: var(--sq-text-3);\n  white-space: nowrap;\n}\n\n.sq-form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.875rem;\n\n  &.is-thirds {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .is-full {\n    grid-column: 1 / -1;\n  }\n\n  @media (max-width: 599px) {\n    grid-template-columns: minmax(0, 1fr);\n\n    &.is-thirds {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n  }\n}\n\n.sq-form-section {\n  padding: 1rem 0;\n  border-top: 1px solid var(--sq-border);\n\n  &:first-child {\n    padding-top: 0;\n    border-top: 0;\n  }\n\n  &:last-child {\n    padding-bottom: 0;\n  }\n\n  > h3 {\n    font-size: 0.875rem;\n    font-weight: 650;\n    margin: 0 0 0.75rem;\n  }\n\n  > p {\n    font-size: 0.8125rem;\n    color: var(--sq-text-3);\n    margin: -0.5rem 0 0.75rem;\n  }\n}\n\n// Segmented control and chips ----------------------------------------------\n\n.sq-seg {\n  display: inline-flex;\n  max-width: 100%;\n  padding: 3px;\n  gap: 2px;\n  background: var(--sq-surface-3);\n  border-radius: var(--sq-radius-sm);\n\n  button {\n    flex: 1 1 auto;\n    appearance: none;\n    border: 0;\n    background: transparent;\n    color: var(--sq-text-2);\n    font-size: 0.8125rem;\n    font-weight: 600;\n    min-height: 30px;\n    padding: 0.2rem 0.7rem;\n    border-radius: 6px;\n    cursor: pointer;\n    white-space: nowrap;\n\n    &:hover {\n      color: var(--sq-text);\n    }\n\n    &[aria-pressed=\"true\"] {\n      background: var(--sq-surface);\n      color: var(--sq-navy);\n      box-shadow: var(--sq-shadow-sm);\n    }\n\n    @media (pointer: coarse), (max-width: $bp-phone) {\n      min-height: 44px;\n      min-width: 44px;\n    }\n  }\n\n  &.is-block {\n    display: flex;\n    width: 100%;\n  }\n}\n\n.sq-chips {\n  display: flex;\n  gap: 0.375rem;\n  flex-wrap: wrap;\n  min-width: 0;\n\n  // One swipeable line on phones rather than a block of wrapped chips.\n  @media (max-width: $bp-phone) {\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    scrollbar-width: none;\n    margin-inline: calc(var(--sq-page-x) * -1);\n    padding-inline: var(--sq-page-x);\n    -webkit-overflow-scrolling: touch;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n}\n\n.sq-chip {\n  appearance: none;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  min-height: 30px;\n  padding: 0.2rem 0.7rem;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: var(--sq-text-2);\n  background: var(--sq-surface);\n  border: 1px solid var(--sq-border-strong);\n  border-radius: 999px;\n  cursor: pointer;\n  white-space: nowrap;\n  text-decoration: none;\n\n  &:hover {\n    border-color: var(--sq-navy);\n    color: var(--sq-navy);\n  }\n\n  &.active,\n  &[aria-pressed=\"true\"] {\n    background: var(--sq-navy);\n    border-color: var(--sq-navy);\n    color: #fff;\n  }\n\n  @media (pointer: coarse), (max-width: $bp-phone) {\n    min-height: 40px;\n  }\n}\n\n// Lists ---------------------------------------------------------------------\n\n.sq-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.sq-list-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  width: 100%;\n  min-height: 52px;\n  padding: 0.625rem 1rem;\n  text-align: left;\n  color: inherit;\n  background: transparent;\n  border: 0;\n  border-bottom: 1px solid var(--sq-border);\n\n  li:last-child > & {\n    border-bottom: 0;\n    border-radius: 0 0 calc(var(--sq-radius) - 1px) calc(var(--sq-radius) - 1px);\n  }\n\n  &.is-clickable {\n    cursor: pointer;\n\n    &:hover {\n      background: var(--sq-surface-2);\n    }\n  }\n}\n\n.sq-list-main {\n  min-width: 0;\n  flex: 1;\n}\n\n.sq-list-title {\n  font-size: 0.875rem;\n  font-weight: 600;\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n\n.sq-list-meta {\n  font-size: 0.8125rem;\n  color: var(--sq-text-3);\n  margin: 0.1rem 0 0;\n  overflow-wrap: anywhere;\n}\n\n// Definition grid -----------------------------------------------------------\n\n.sq-dl {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));\n  gap: 0.875rem 1.25rem;\n  margin: 0;\n  padding: 1rem;\n\n  @media (max-width: $bp-phone) {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  > div {\n    min-width: 0;\n  }\n\n  dt {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n    font-size: 0.75rem;\n    font-weight: 500;\n    color: var(--sq-text-3);\n    margin: 0 0 0.1rem;\n  }\n\n  dd {\n    margin: 0;\n    font-size: 0.875rem;\n    font-weight: 500;\n    overflow-wrap: anywhere;\n  }\n\n  .is-wide {\n    grid-column: 1 / -1;\n  }\n}\n\n.sq-dl-rows {\n  display: grid;\n  gap: 0.625rem;\n  margin: 0;\n\n  > div {\n    display: grid;\n    grid-template-columns: 9.5rem minmax(0, 1fr);\n    gap: 0.75rem;\n\n    @media (max-width: 479px) {\n      grid-template-columns: minmax(0, 1fr);\n      gap: 0.05rem;\n    }\n  }\n\n  dt {\n    font-size: 0.8125rem;\n    font-weight: 500;\n    color: var(--sq-text-3);\n  }\n\n  dd {\n    margin: 0;\n    font-size: 0.875rem;\n    min-width: 0;\n    overflow-wrap: anywhere;\n  }\n}\n\n// Feedback ------------------------------------------------------------------\n\n.sq-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 0.25rem;\n  padding: 2rem 1.25rem;\n  color: var(--sq-text-3);\n\n  svg {\n    color: var(--sq-text-3);\n    opacity: 0.75;\n    margin-bottom: 0.25rem;\n  }\n\n  h3 {\n    font-size: 0.9375rem;\n    font-weight: 600;\n    color: var(--sq-text-2);\n    margin: 0;\n  }\n\n  p {\n    font-size: 0.8125rem;\n    margin: 0;\n    max-width: 34rem;\n  }\n\n  .btn {\n    margin-top: 0.5rem;\n  }\n\n  &.is-compact {\n    padding: 1.25rem 1rem;\n  }\n}\n\n.sq-error {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  padding: 0.625rem 0.875rem;\n  margin-bottom: 1rem;\n  font-size: 0.875rem;\n  color: var(--sq-bad);\n  background: var(--sq-bad-bg);\n  border: 1px solid var(--sq-bad-line);\n  border-radius: var(--sq-radius-sm);\n  overflow-wrap: anywhere;\n\n  > span {\n    display: inline-flex;\n    gap: 0.4rem;\n    min-width: 0;\n    flex: 1 1 12rem;\n  }\n\n  svg {\n    flex-shrink: 0;\n    margin-top: 0.1rem;\n  }\n}\n\n.sq-skel {\n  display: block;\n  height: 0.8125rem;\n  border-radius: 6px;\n  background: linear-gradient(90deg, #e8edf3 25%, #f2f5f8 37%, #e8edf3 63%);\n  background-size: 400% 100%;\n  animation: sq-shimmer 1.4s ease infinite;\n\n  &.is-tall {\n    height: 1.625rem;\n  }\n}\n\n.sq-skel-rows {\n  display: flex;\n  flex-direction: column;\n  gap: 0.875rem;\n  padding: 1rem;\n}\n\n@keyframes sq-shimmer {\n  0% {\n    background-position: 100% 50%;\n  }\n\n  100% {\n    background-position: 0 50%;\n  }\n}\n\n.sq-meter {\n  display: block;\n  height: 8px;\n  border-radius: 4px;\n  background: var(--sq-surface-3);\n  overflow: hidden;\n\n  > i {\n    display: block;\n    height: 100%;\n    min-width: 4px;\n    border-radius: 4px;\n    background: var(--sq-navy);\n  }\n}\n\n// Disclosure used for optional panels (\"About integrations\", filters on phones).\n.sq-disclosure {\n  > summary {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.3rem;\n    min-height: 32px;\n    font-size: 0.8125rem;\n    font-weight: 600;\n    color: var(--sq-navy);\n    cursor: pointer;\n    list-style: none;\n    user-select: none;\n\n    &::-webkit-details-marker {\n      display: none;\n    }\n\n    @media (pointer: coarse) {\n      min-height: 44px;\n    }\n  }\n\n  > summary svg {\n    transition: transform 0.15s ease;\n  }\n\n  &[open] > summary svg.sq-chevron {\n    transform: rotate(90deg);\n  }\n}\n\n.sq-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.5rem 0.75rem;\n  padding: 0.625rem 1rem;\n  font-size: 0.8125rem;\n  color: var(--sq-text-3);\n  border-top: 1px solid var(--sq-border);\n\n  .sq-page-btns {\n    display: flex;\n    align-items: center;\n    gap: 0.375rem;\n\n    @media (max-width: $bp-phone) {\n      width: 100%;\n\n      .btn {\n        flex: 1;\n      }\n    }\n  }\n}\n\n// Stacked-table density ----------------------------------------------------\n\n@media (max-width: $bp-phone) {\n  .sq-table.is-stacked {\n    // Number-heavy rows (site counts) sit on one line rather than a tall card.\n    &.cols-3 tbody > tr {\n      grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n\n    &.cols-4 tbody > tr {\n      grid-template-columns: repeat(4, minmax(0, 1fr));\n    }\n\n    &.cols-5 tbody > tr {\n      grid-template-columns: repeat(5, minmax(0, 1fr));\n    }\n\n    td.cell-title {\n      order: -1;\n    }\n\n    // A table nested in an expanded row is already inside a card.\n    .sq-table.is-stacked tbody {\n      padding: 0;\n    }\n  }\n}\n\n// Row toggle (expandable tables) --------------------------------------------\n\n.sq-row-toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  color: var(--sq-text-3);\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  cursor: pointer;\n\n  &:hover {\n    color: var(--sq-navy);\n    background: var(--sq-surface-3);\n  }\n\n  @media (pointer: coarse), (max-width: $bp-phone) {\n    width: 44px;\n    height: 44px;\n  }\n}\n\n.sq-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  color: var(--sq-text-2);\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  cursor: pointer;\n\n  &:hover {\n    color: var(--sq-navy);\n    background: var(--sq-surface-3);\n  }\n\n  &.is-danger:hover {\n    color: var(--sq-bad);\n    background: var(--sq-bad-bg);\n  }\n\n  @media (pointer: coarse), (max-width: $bp-phone) {\n    width: 44px;\n    height: 44px;\n  }\n}\n\n.sq-text-link {\n  color: var(--sq-navy);\n  font-weight: 600;\n  text-decoration: none;\n\n  // Bigger hit area without moving the surrounding text.\n  @media (pointer: coarse), (max-width: $bp-phone) {\n    display: inline-block;\n    padding-block: 0.7rem;\n    margin-block: -0.7rem;\n  }\n\n  &:hover {\n    color: var(--sq-brand-strong);\n    text-decoration: underline;\n  }\n}\n\n.sq-tasks {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.25rem;\n}\n\n// Filters: always open on desktop, behind a toggle on phones ----------------\n\n.sq-filters-toggle {\n  display: none;\n\n  @media (max-width: $bp-phone) {\n    display: inline-flex;\n    width: 100%;\n  }\n}\n\n.sq-filters-body {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0.625rem;\n  flex: 1 1 100%;\n  min-width: 0;\n\n  @media (max-width: $bp-phone) {\n    &:not(.is-open) {\n      display: none;\n    }\n  }\n}\n\n.sq-form-actions {\n  display: flex;\n  align-items: flex-end;\n  gap: 0.5rem;\n\n  @media (max-width: $bp-phone) {\n    width: 100%;\n\n    .btn {\n      flex: 1;\n    }\n  }\n}\n\n.reports-filter {\n  align-items: flex-end;\n}\n\n// A card heading that also expands the card.\n.sq-card-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  min-height: 28px;\n  padding: 0;\n  font: inherit;\n  color: inherit;\n  background: transparent;\n  border: 0;\n  border-radius: 4px;\n  cursor: pointer;\n\n  &:hover {\n    color: var(--sq-navy);\n  }\n\n  @media (pointer: coarse) {\n    min-height: 44px;\n  }\n}\n\n.sq-clamp {\n  display: -webkit-box;\n  max-width: 34rem;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n}\n\n// Attention panels read first on phones, then sit beside the main column.\n.sq-columns.is-aside-first {\n  @media (min-width: 1280px) {\n    > aside {\n      order: 2;\n    }\n  }\n}\n\n// Footer and not-found ------------------------------------------------------\n\n.sq-footer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 0.25rem 1rem;\n  padding: 0.875rem var(--sq-page-x);\n  font-size: 0.75rem;\n  color: var(--sq-text-3);\n\n  a {\n    color: var(--sq-text-2);\n    font-weight: 600;\n    text-decoration: none;\n\n    @media (pointer: coarse), (max-width: $bp-phone) {\n      display: inline-block;\n      padding-block: 0.8rem;\n      margin-block: -0.8rem;\n    }\n\n    &:hover {\n      color: var(--sq-navy);\n      text-decoration: underline;\n    }\n  }\n}\n\n.sq-not-found {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 0.5rem;\n  padding-top: 3rem;\n\n  img {\n    width: min(100%, 220px);\n    height: auto;\n  }\n\n  h1 {\n    font-size: 1.375rem;\n    font-weight: 700;\n    margin: 0.75rem 0 0;\n  }\n\n  p {\n    color: var(--sq-text-3);\n    margin: 0 0 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
